<template>
  <div class="tkCabin full-height linear-main3">
    <ld-header
      :transparent="true"
      :white="true"
    >
      <span v-show="tkSearchInfo.queryStr.travelType == 2 && tkSearchInfo.roundtrip == 0">{{ $t('C174', '去程') }}：</span>
      <span v-show="tkSearchInfo.queryStr.travelType == 2 && tkSearchInfo.roundtrip == 1">{{ $t('C175', '返程') }}：</span>
      <!-- {{ tkSearchInfo.depport.cityName }} ⇀ {{ tkSearchInfo.arrport.cityName }} -->

      <!-- {{ tkSearchInfo.depport.cityName }} ⇀ {{ tkSearchInfo.arrport.cityName }}  -->
      <span v-show="tkSearchInfo.queryStr.travelType == 2 && tkSearchInfo.roundtrip == 0">{{ this.tkSearchInfo.queryStrWF.depport.cityName }} ⇀ {{ this.tkSearchInfo.queryStrWF.arrport.cityName }} </span>
      <span v-show="tkSearchInfo.queryStr.travelType == 2 && tkSearchInfo.roundtrip == 1">{{ this.tkSearchInfo.queryStr.depport.cityName }}⇀{{ this.tkSearchInfo.queryStr.arrport.cityName }}</span>
      <span v-show="tkSearchInfo.queryStr.travelType == 1">{{ tkSearchInfo.depport.cityName }} ⇀ {{ tkSearchInfo.arrport.cityName }} </span>
    </ld-header>
    <div class="box">
      <!--  -->
      <travel-tips
        v-if="tkSearchInfo.arrport.cityId"
        :arrive-cityid="tkSearchInfo.arrport.cityId"
        :depport-cityid="tkSearchInfo.depport.cityId"
        cplx="10901"
        :auto-popup="true"
      />

      <div class="cabinTitle">
        <div v-if="tkSearchInfo.queryStr.travelType == 2">
          <voyage
            :flights="(tkSearchInfo.queryStr.travelType == 2 && tkSearchInfo.roundtrip == 1) ? [tkSearchInfo.flights[1]] : [tkSearchInfo.flights[0]]"
            :round-trip="tkSearchInfo.roundtrip"
            :travel-type="tkSearchInfo.queryStr.travelType"
          />
        </div>
        <div v-else>
          <voyage
            :flights="tkSearchInfo.flights.length > 1 ? [tkSearchInfo.flights[1]] : [tkSearchInfo.flights[0]]"
            :round-trip="tkSearchInfo.roundtrip"
            :travel-type="tkSearchInfo.queryStr.travelType"
          />
        </div>
      </div>

      <!-- 舱位列表 -->
      <div class="tkCabinwrapper">
        <mescroll-vue
          ref="mescroll"
          :down="down"
        >
          <div>
            <div>
              <van-tabs
                v-model="active"
                @change="changeTab"
                :ellipsis="false"
                line-width="50"
                line-height="3"
              >
                <van-tab
                  v-for="(item, index1) in cabinTypeList"
                  :key="index1"
                  :disabled="item.disabled"
                >
                  <template #title>
                    <div
                      :class="{ 'main-color': (active == index1) }"
                      v-if="item.cabinTypeName"
                    >
                      <p class="font-bold">
                        {{ item.cabinTypeName }}
                      </p>
                      <p class="font12 text-center">
                        &yen; {{ item.minPrice }} 起
                      </p>
                    </div>
                  </template>
                  <div class="borderBotRadius overflow">
                    <div v-for="(info, index3) in item.minPriceCabin" :key="index3" class="van-hairline--bottom  newharignl">
                      <div class="markListbox main-color">
                        <span class="maskclice" v-if="markListone(info)">  {{ markListone(info) }}</span>
                      </div>
                      <van-cell :class="[markListone(info) ? 'harignl' : '']">
                        <van-row align="center" class="" type="flex">
                          <van-col span="20">
                            <van-row align="center" class="cabinList" type="flex">
                              <van-col span="17">
                                <span
                                  v-if="info.salePrice"
                                  class="main-color font12 font-bold"
                                >
                                  &yen;<span class="font20">{{ info.salePrice }}</span>
                                </span>
                                <span
                                  v-else
                                  class="font14 main-color"
                                  @click="getPriceForFloat(info, 'minPriceCabin', index1, index3)"
                                >
                                  {{ $t('B030', '获取价格') }}
                                </span>
                                <span
                                  class="line-through gray"
                                  v-if="info.oldSalePrice"
                                >
                                  &yen;{{ info.oldSalePrice }}
                                </span>
                                <span v-show="showProduct(index3)">
                                  &nbsp;
                                  <van-tag
                                    v-if="info.tagText ? true: false"
                                    :color="info.tagColor"
                                  >
                                    {{ info.tagText }}
                                  </van-tag>
                                  <van-tag
                                    v-else
                                    v-show="info.productType != 1 && info.productType != 6"
                                    :color="info.productType | productTypeColor"
                                  >
                                    {{ info.productType | productType }}
                                  </van-tag>

                                </span>
                              </van-col>

                              <van-col
                                span="7"
                                class="text-center"
                              >
                                <div
                                  class="wei"
                                  v-if="tkSearchInfo.violateList && tkSearchInfo.violateList[info.priceId] && tkSearchInfo.violateList[info.priceId]['violateItem']"
                                >
                                  {{ contraryto }}
                                </div>&nbsp;
                                <span
                                  v-show="1 != index3"
                                  class="gray font10"
                                >{{ info.seatCount | seatCount }}</span>
                              </van-col>
                            </van-row>
                            <div
                              class="ert"
                              v-if="tkSearchInfo.showchildren"
                            >
                              <span
                                class="ert"
                                v-if="info.chdSalePrice"
                              >儿童&yen;</span>
                              <span class="ert">{{ info.chdSalePrice }}</span>
                            </div>
                            <div
                              class="font12 st"
                              @click="showRule(info.cabin, info.priceId)"
                            >
                              <p>
                                {{ info.cabinName }} <span v-if="showCabin"> {{ info.cabin }} / </span> {{
                                  info.trasferDiscount
                                }} |
                                {{ info.tgfy }} | {{ info.baggageWeight }}>
                              </p>
                              <!--                              青老年文案-->
                              <!-- <p>
                                <span v-for="(item,index) in info.markList" :key="index">
                                  <span class="YoungAndOld">{{ item.markDesc }}</span>
                                </span>
                              </p> -->
                            </div>
                          </van-col>
                          <van-col class="text-right" span="4">
                            <div v-if="tkSearchInfo.violateList && tkSearchInfo.violateList[info.priceId] && tkSearchInfo.violateList[info.priceId].canBook == 0" class="gray font10" style="width:62px;">
                              {{ $t('Unbookable', '不可预订') }}
                            </div>
                            <div v-else>
                              <ld-button v-if="1 != index3 || showCabinStatus" main size="party" @click.native="book(info, info, info.priceId)">
                                订
                              </ld-button>
                            </div>
                          </van-col>
                        </van-row>
                      </van-cell>
                      <div>
                        <div class="back_padd">
                          <div class="dis_juc_vut" style="margin-bottom: 5px;" v-if="info.markList && luggage(info.markList)">
                            <i class="iconfont icon-biaoqian2 iconfontcolr main-color"/>
                            <div>{{ luggage(info.markList) }}</div>
                          </div>

                          <div class="dis_juc_wra" v-if="info.markList && info.markList.length > 1 ">
                            <template v-for="(item,index) in info.markList" >
                              <div v-if="!item.markDesc.includes('行李') && index!=0" :key="index" class="width50">
                                <i class="iconfont icon-biaoqian2 iconfontcolr main-color"/>
                                <span>{{ item.markDesc }}</span>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="item.showMore && showMoreCabin" class="pad-tb-6 ">
                    <van-collapse v-model="activeNames" accordion class="borderRadius overflow" @change="changeCollapse(index1)">
                      <van-collapse-item v-if="item.otherPriceCabin" name="1">
                        <template #title>
                          <span class="black font-bold"> 更多{{ item.cabinTypeName }}位</span>
                        </template>
                        <template #value>
                          <span class="main-color font-bold">&yen; {{ item.otherPrice }} 起 &nbsp;</span>
                          <!-- <span class="black font-bold"> {{ item.activeNames ? '收起' : '展开' }}</span> -->
                        </template>
                        <!-- 下面更 -->
                        <div v-for="(info, index5) in item.otherPriceCabin" :key="index5" class="newharignltow">
                          <!-- 第一行 -->
                          <div class="markListbox main-color">
                            <span class="maskclice" v-if="markListone(info)">  {{ markListone(info) }}</span>
                          </div>
                          <!-- 第二行中间内容 -->
                          <div class="van-hairline--bottom pad-tb-10 newhairline" :class="[markListone(info) ? 'harignnew' : '']">
                            <van-row align="center" type="flex">
                              <van-col span="20">
                                <van-row align="center" class="cabinList" type="flex">
                                  <van-col span="17">
                                    <span v-if="info.salePrice" class="main-color font12 font-bold">
                                      &yen;<span class="font20">{{ info.salePrice }} </span>
                                    </span>
                                    <span v-else class="font14 main-color" @click="getPriceForFloat(info, 'otherPriceCabin', index1, index3)">
                                      {{ $t('B030', '获取价格') }}
                                    </span>
                                    <span
                                      class="line-through gray"
                                      v-if="info.oldSalePrice"
                                    >
                                      &yen;{{ info.oldSalePrice }}
                                    </span>

                                    <span>&nbsp;
                                      <van-tag
                                        v-if="info.tagText ? true: false"
                                        :color="info.tagColor"
                                      >
                                        {{ info.tagText }}
                                      </van-tag>
                                      <van-tag
                                        v-else
                                        v-show="info.productType != 1 && info.productType != 6"
                                        :color="info.productType | productTypeColor"
                                      >
                                        {{ info.productType | productType }}
                                      </van-tag>
                                    </span>
                                  </van-col>

                                  <van-col
                                    span="7"
                                    class="text-center"
                                  >
                                    <div
                                      class="wei"
                                      v-if="tkSearchInfo.violateList && tkSearchInfo.violateList[info.priceId] && tkSearchInfo.violateList[info.priceId]['violateItem']"
                                    >
                                      {{ contraryto }}
                                    </div>&nbsp;
                                    <span class="gray font10">{{ info.seatCount | seatCount }}</span>
                                  </van-col>
                                </van-row>
                                <div
                                  v-if="tkSearchInfo.showchildren"
                                  class="ert1"
                                >
                                  <span
                                    class="ert"
                                    v-if="info.chdSalePrice"
                                  >儿童&yen;</span>
                                  <span class="ert">{{ info.chdSalePrice }}</span>
                                </div>
                                <div
                                  class="font12 st"
                                  @click="showRule(info.cabin, info.priceId)"
                                >
                                  <p>
                                    {{ info.cabinName }} <span v-if="showCabin"> {{ info.cabin }} / </span> {{
                                      info.trasferDiscount
                                    }} |
                                    {{ info.tgfy }} | {{ info.baggageWeight }}>
                                  </p>
                                  <!--                              青老年文案-->
                                  <!-- <p>
                                    <span
                                      v-for="(item,index) in info.markList"
                                      :key="index"
                                    >
                                      <span class="YoungAndOld">{{ item.markDesc }}</span>
                                    </span>
                                  </p> -->
                                </div>
                              </van-col>
                              <van-col
                                span="4"
                                class="text-right"
                              >
                                <div
                                  class="gray font10"
                                  style="width:62px;"
                                  v-if="tkSearchInfo.violateList && tkSearchInfo.violateList[info.priceId] && tkSearchInfo.violateList[info.priceId].canBook == 0"
                                >
                                  {{ $t('Unbookable', '不可预订') }}
                                </div>
                                <ld-button
                                  v-else
                                  size="party"
                                  main
                                  @click.native="book(info, info, info.priceId)"
                                >
                                  订
                                </ld-button>
                              </van-col>
                            </van-row>
                          </div>
                          <!-- 第三行 -->
                          <div>
                            <div class="back_padd">
                              <div class="dis_juc_vut" style="margin-bottom: 5px;" v-if="info.markList && luggage(info.markList)" >
                                <i class="iconfont icon-biaoqian2 iconfontcolr main-color"/>
                                <div >{{ luggage(info.markList) }}</div>
                              </div>

                              <div class="dis_juc_wra" v-if="info.markList && info.markList.length > 1 ">
                                <template v-for="(item,index) in info.markList" >
                                  <div v-if="!item.markDesc.includes('行李') && index!=0" :key="index" class="width50">
                                    <i class="iconfont icon-biaoqian2 iconfontcolr main-color"/>
                                    <span>{{ item.markDesc }}</span>
                                  </div>
                                </template>
                              </div>
                            </div>
                          </div>
                        </div>
                      </van-collapse-item>
                    </van-collapse>
                  </div>
                </van-tab>
              </van-tabs>
            </div>

            <!--  -->
            <!-- <div style="height:50px;">
                &nbsp;
            </div> -->
            <!--  -->
            <!-- <div>
              <div
                class="cabinListBox list-content"
                v-for="(info ,index) in cabinTypeList"
                :key="index"
              >
                <div
                  class="dropdown"
                  @click="showMore(index)"
                >
                  <span class="fl font14 black">{{ info.cabinTypeName }}</span>
                  <span class="fr font18 ">
                    <van-icon
                      class="main-color"
                      v-show="info.limit==1"
                      name="arrow-down"
                    />
                    <van-icon
                      class="main-color"
                      v-show="info.limit>1"
                      name="arrow-up"
                    />
                  </span>
                </div>
                <div
                  class="cabinListContent"
                  v-for="(value ,key) in info.cabinMap"
                  v-show="key<info.limit"
                  :key="key"
                >
                  <div
                    class="van-hairline--top"
                    v-for="(v ,k) in value.priceList"
                    :key="k"
                  >
                    <van-row
                      type="flex"
                      align="center"
                      class="cabinList"
                    >
                      <van-col span="14">
                        <van-row
                          type="flex"
                          align="center"
                        >
                          <van-col span="8">
                            <div
                              class="red font12"
                              v-if="v.salePrice"
                            >
                              &yen;<span class="font20">{{ v.salePrice }}</span>
                            </div>
                            <div
                              v-else
                              class="font14"
                              @click="getPriceForFloat(v,value,info.cabinType)"
                            >
                              {{ $t('B030','获取价格') }}
                            </div>
                          </van-col>
                          <van-col span="16">
                            <span class="gray font12"> {{ v.discount | discount }}</span> &nbsp;
                            <span v-if="showCabin">{{ value.cabin }}&nbsp;</span>
                            <van-tag
                              v-show="v.productType && v.productType!=1 && v.productType!=6"
                              plain
                              :color="v.productType | productTypeColor"
                            >
                              {{ v.productType | productType }}
                            </van-tag>
                          </van-col>
                        </van-row>
                        <div class="pad-tb-4">
                          <span
                            v-for="pdt in v.markList"
                            :key="pdt.markCode"
                          >
                            <van-tag plain>
                              {{ pdt.markDesc }}
                            </van-tag>&nbsp;</span>
                        </div>
                        <van-row class="font12">
                          <van-col
                            span="24"
                            class="main-color"
                            @click.native="showRule(value.cabin,v.priceId)"
                          >
                            {{ v.tgfy }} | {{ v.baggageWeight }}
                          </van-col>
                        </van-row>
                      </van-col>
                      <van-col
                        span="5"
                        class="text-center"
                      >
                        <div
                          class="wei"
                          v-if="tkSearchInfo.violateList&&tkSearchInfo.violateList[v.priceId]&&tkSearchInfo.violateList[v.priceId]['violateItem']"
                        >
                          {{ $t('K303','违') }}
                        </div>&nbsp;
                        <span class="gray font10">{{ v.seatCount | seatCount }}</span>
                      </van-col>
                      <van-col span="5">
                        <div
                          class="gray font10"
                          style="width:62px;"
                          v-if="tkSearchInfo.violateList&&tkSearchInfo.violateList[v.priceId]&&tkSearchInfo.violateList[v.priceId].canBook==0"
                        >
                          {{ $t('Unbookable','不可预订') }}
                        </div>
                        <ld-button
                          v-else
                          size="md"
                          main
                          style="width:62px;height:30px;"
                          @click.native="book(v,value,v.priceId)"
                        >
                          {{ $t('B003','预订') }}
                        </ld-button>
                      </van-col>
                    </van-row>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
          <nomore />
        </mescroll-vue>
      </div>
      <!-- 退改签规则 -->
      <refund-change-rule ref="rule" :obj="changeRule" />
    </div>

    <van-dialog v-model="showModal" :before-close="tobook" :confirm-button-text="$t('B012', '继续预订')" show-cancel-button title="预订提示">
      <div>
        <div class="font12 pad-10">
          <p class="indent">
            {{ prodectTips.str1 }}
          </p>
          <p class="indent">
            {{ prodectTips.str2 }}
          </p>
        </div>
        <van-radio-group
          v-model="haveRead"
          class="font10"
        >
          <van-radio
            name="1"
            class="pad-10"
          >
            <span class="nav-gray">{{ prodectTips.str3 }}</span>
          </van-radio>
        </van-radio-group>
      </div>
    </van-dialog>

    <violate-list ref="violateList" :violate="tkSearchInfo.violate" :lv-show="lvShow" cplx="10901" @selected="noTimeOut" />
    <!-- 弹出框 -->
    <van-popup v-model="showBottomfraud" :style="{ height: '25vh',width:'74vw' }" @close="nextstep=true">
      <div v-if="nextstep" class="fraudl">
        <div>该报价非本航班最低报价，是否继续预订？</div>
        <div class="select">
          <van-button type="primary" size="small" style=" width: 48px;height: 24px" color="#169BD5" @click="nextstep=false">
            是
          </van-button>
          <van-button type="primary" size="small" style=" width: 48px;height: 24px" color="#CB0000" @click="showBottomfraud=false">
            否
          </van-button>
        </div>
      </div>
      <div v-else class="reason">
        <div>
          请输入选择该报价原因：
          <van-field class="fieldcas" v-model="selectreason" rows="2" :autosize="{maxHeight:'100%'}" type="textarea" maxlength="200" placeholder="请输入留言" show-word-limit required />
        </div>
        <div class="selectokd">
          <van-button type="primary" size="small" style=" width: 48px;height: 24px" color="#169BD5" @click="selectook(infoprice)">
            确定
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import 'Assets/font/download1/iconfont.css'

import {mapGetters,mapState} from 'vuex'
import MescrollVue from 'mescroll.js/mescroll.vue'
import {objToArr} from 'Utils/object.js'
import {Cell, Collapse, CollapseItem, Radio, RadioGroup, Tab, Tabs, Tag,Dialog,Popup,Button,Field} from 'vant'

import ldHeader from 'Common/ldHeader'
import nomore from 'Common/ldNoMore'
import ldButton from 'Common/ldButton'
import voyage from 'Components/tk/voyage'
import refundChangeRule from 'Components/refundChangeRule'
import violateList from 'Components/violateList'
import orderMixin from '@/business/views/Home/allorder/components/orderMixin'
import travelTips from 'Components/travelTips'

export default {
  name: 'TkCabin',
  mixins: [orderMixin],
  components: {
    ldHeader,
    nomore,
    ldButton,
    voyage,
    refundChangeRule,
    violateList,
    MescrollVue,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Tag.name]: Tag,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Cell.name]: Cell,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Popup.name]: Popup,
    [Dialog.name]: Dialog,
    travelTips,
    [Button.name]: Button,
    [Field.name]:Field,
  },
  data() {
    return {
      i: '',
      down: {use: false},
      changeRule: {},//退改规则参数
      closeFB: 0,//是否隐藏公务舱头等
      limitCabin: 0,//展开收起
      showModal: false,//显示弹窗
      haveRead: false,//已阅
      prodectTips: {},//展示提示信息
      price: {},
      cabin: {},
      wbxs: {},
      showCabin: false,
      showMoreCabin: true,
      showCabinStatus: true,
      showCabinDecStatus: true,
      ylslCabin: false,
      showProductTypeTips: true,
      showFirstProductTypeTips: false,
      showFirstProductTypeColor: '',
      showFirstProductTypeText: '',
      active: '',
      cabinTypeList: [],
      sn1list: [],
      lvShow: false,//是否是龙旅
      showBottomfraud: false,//判断是否最低价显示
      infoprice: '', //存选择中的条数
      nextstep: true, //弹窗第一页
      selectreason: '',//选择报价的原因
      activeNames:'1'

    }
  },
  computed: {
    ...mapGetters({
      tkSearchInfo: 'tk/tkSearchInfo',
      travelerList: 'tk/travelerList',
      tripType: 'tripType',
      userInfo: 'userInfo'
    }),
    ...mapState({
      vipCorp: state => state.app.userInfo.vipCorp
    }),
    flights() {//当前航班信息
      return this.tkSearchInfo.flights[this.tkSearchInfo.roundtrip]
    },
    contraryto(){
      let temp = window.location.href;
      if (temp.includes("app.xinglu.com")) {
        return '超'
      } else {
        return this.$t('K303', '违')
      }
    },
    // cabinList(){// 要展示的舱位列表
    // 	let arr=objToArr(this.cabinTypeList)
    // 	//显示头等 公务
    // 	if (this.closeFB == 1) {
    // 		arr = closeFB(arr)
    // 	}
    // 	//显示最低舱位
    // 	arr = limitCabin(arr,this.limitCabin)
    // 	return arr
    // },
    path() {
      //航班列表 返程
      if (this.tkSearchInfo.queryStr.travelType == 2 && this.tkSearchInfo.roundtrip == 0) {//往返的第一程
        if (this.tkSearchInfo.queryStr.travelType == 2 && this.tkSearchInfo.roundtrip == 0) {
          this.tkSearchInfo.roundtrip += 1
        }
        return '/tk/tkList'
      } else if (this.tkSearchInfo.path) {
        return this.tkSearchInfo.path
      }
      return '/tk/tkEdit'
    },
  },
  created() {
    let query=this.$route.query
    if(query.roundtrip){//浏览器回退往返第一屏
      console.log('query.roundtrip',query.roundtrip)
      if(this.tkSearchInfo.queryStr.travelType == 2 && this.tkSearchInfo.roundtrip == 1){
        this.tkSearchInfo.roundtrip=0
      }
    }
    this.isLvShow()
    Promise.all([
      new Promise((resolve) => {
        this.$api['common/queryVipParameter']({
          paramNo: '11601023'
        }).then(res => {
          let cache = res.data || {}
          this.ylslCabin = cache.value1 == 1 ? true : false
          resolve(cache)
        })
        this.$api['common/queryVipParameter']({
          paramNo: '11601019'
        }).then(res => {
          let cache = res.data || {}
          this.showCabin = cache.value1 == 0 ? false : true
        })
        this.$api['common/queryVipParameter']({
          paramNo: '11601020'
        }).then(res => {
          let cache = res.data || {}
          this.showMoreCabin = cache.value1 == 1 ? false : true
        })
        this.$api['common/queryVipParameter']({
          paramNo: '11601021'
        }).then(res => {
          let cache = res.data || {}
          this.showCabinStatus = cache.value1 == 1 ? false : true
        })
        this.$api['common/queryVipParameter']({
          paramNo: '11601031'
        }).then(res => {
          let cache = res.data || {}
          this.showCabinDecStatus = cache.value1 == 1 ? false : true
        })
        this.$api['common/queryVipParameter']({
          paramNo: '11601022'
        }).then(res => {
          let cache = res.data || {}
          this.showProductTypeTips = cache.value1 == 1 ? false : true
          this.showFirstProductTypeTips = cache.value2 == 1 ? true : false
          if (this.showFirstProductTypeTips) {
            this.$api['common/queryVipParameter']({
              paramNo: '11601024'
            }).then(resp => {
              let cacheProduct = resp.data || {}
              this.showFirstProductTypeText = cacheProduct.value2
              this.showFirstProductTypeColor = cacheProduct.value1
            })
          }
        })
      })
    ]).then(this.init)
  },
  methods: {
    markListone(info) {
      if (info.markList && info.markList[0].markDesc) {
        return info.markList[0].markDesc
      }
    },
    luggage(info){
      if(info.length ==0){
        return false
      }
      let one=info.filter((item)=> item.markDesc.includes('行李'))
      if(one.length==1){
        return one[0].markDesc
      }else{
        let tow=one.filter((item)=> item.markDesc.includes('行李') && item.markDesc('CM') && item.markDesc("尺寸"))
        if(tow.length==1){
          return tow[0].markDesc
        }else{
          return false
        }
      }

    },

    init() {
      if (this.tkSearchInfo.matchClbz) {
        this.matchClbz()
      }


      if (this.tripType == 1) {
        let self = this
        this.$api['common/queryParameter']({
          'paramNos': '10994,10997'
        }).then(res => {
          let cache = res.data || {}
          cache.parameterResponses.forEach(item => {
            // 如果是预订全免的、或者因私，不受此参数限制
            if (item.paramNo == '10994') {
              self.limitCabin = (self.userInfo.empInfo.appBook == 1 ? 0 : (item.value1 > 0 ? item.value1 : 0))
            }
            //let obj={'F':'头等舱','B':'公务舱','E':'经济舱','ES':'高端经济舱/明珠舱','T':'特价舱'};
            //隐藏公务/头等舱价格// 如果是预订全免的、或者因私，不受此参数限制
            if (item.paramNo == '10997') {
              self.closeFB = (self.userInfo.empInfo.appBook == 1 ? 0 : (item.value1 == 1 ? item.value1 : 0))
            }
          })
          this.initCabin()
        })
      } else {
        this.initCabin()
      }
    },
    initCabin() {
      let arr = objToArr(this.flights.cabinTypeList)
      //显示头等 公务
      if (this.closeFB == 1) {
        arr = closeFB(arr)
      }
      //显示最低舱位
      arr = limitCabin(arr, this.limitCabin)
      for (let i = 0; i < arr.length; i++) {
        arr[i].activeNames = ''
        arr[i].limit = 1
        arr[i].isshow = true
        if (arr[i].cabinTypeName == '经济舱') {
          arr[i].list = 1
        } else if (arr[i].cabinTypeName == '明珠经济舱') {
          arr[i].list = 2
        } else if (arr[i].cabinTypeName == '高端经济舱') {
          arr[i].list = 2
        } else if (arr[i].cabinTypeName == '高级经济舱') {
          arr[i].list = 2
        } else if (arr[i].cabinTypeName == '超级经济舱') {
          arr[i].list = 2
        }  else {
          arr[i].list = 3
        }
        if (arr[i].cabinMap.length > 1) {
          arr[i].showMore = true
        } else if (arr[i].cabinMap.length == 1) {
          if (arr[i].cabinMap[0].priceList.length == 1) {
            arr[i].showMore = false
          } else {
            arr[i].showMore = true
          }
        }
        var minPriceCabin = []
        var otherPriceCabin = []
        arr[i].cabinMap.forEach(item => {
          item.priceList.forEach(el => {
            el.cabin = item.cabin
            el.cabinName = item.cabinName
            el.minPrice = item.minPrice

            if (el.minPriceFlag == 1 || (el.discount == 10 || this.ylslCabin)) {
              if (this.ylslCabin) {
                //银联商旅特殊处理
                if (i == 0) {
                  //经济
                  if (el.cabin == arr[0].cabinMap[0].cabin && arr[0].cabinMap[0].minPrice == el.salePrice) {
                    if (minPriceCabin.length == 0) {
                      minPriceCabin.push(el)
                    }
                  } else if (10 == el.discount && 3 == el.productType && 'Y' == el.cabin) {
                    minPriceCabin.push(el)
                  }
                } else if (1 == i) {
                  if (el.cabin == arr[1].cabinMap[0].cabin && arr[1].cabinMap[0].minPrice == el.salePrice) {
                    if (minPriceCabin.length == 0) {
                      minPriceCabin.push(el)
                    }
                  } else if (10 == el.discount && 1 == el.productType && 'J' == el.cabin) {
                    minPriceCabin.push(el)
                  }
                } else if (2 == i) {
                  if (el.cabin == arr[2].cabinMap[0].cabin && arr[2].cabinMap[0].minPrice == el.salePrice) {
                    if (minPriceCabin.length == 0) {
                      minPriceCabin.push(el)
                    }
                  } else if (10 == el.discount && 1 == el.productType && 'F' == el.cabin) {
                    minPriceCabin.push(el)
                  }
                }
              } else {
                minPriceCabin.push(el)
              }
            } else {
              otherPriceCabin.push(el)
            }
          })
        })
        if (minPriceCabin.length) {
          minPriceCabin.sort((a, b) => {
            if (a.salePrice && b.salePrice) {
              return a.salePrice - b.salePrice
            } else {
              return 1
            }
          })
          arr[i].minPrice = minPriceCabin[0].salePrice
          arr[i].minPriceCabin = minPriceCabin
        }
        if (otherPriceCabin.length) {
          otherPriceCabin.sort((a, b) => {
            if (a.salePrice && b.salePrice) {
              return a.salePrice - b.salePrice
            } else {
              return 1
            }
          })
          arr[i].otherPrice = otherPriceCabin[0].salePrice
          arr[i].otherPriceCabin = otherPriceCabin
          arr[i].showMore = true
        }
      }
      if (arr.length == 1) {
        arr.push({disabled: true}, {disabled: true})
      }
      arr.sort((a, b) => {
        if (a.list && b.list) {
          return a.list - b.list
        } else {
          return 1
        }
      })
      //循环他的数组位置将带有经济的调前
      if(arr.length > 1){
        arr.sort((a, b) => {
          // 将第一个经济舱保持在数组最前面
          if (a === '经济舱') {
            return -1;
          } else if (b === '经济舱') {
            return 1;
          }
          let isContainA
          let isContainB
          // 判断舱名中是否包含"经济"两个字
          a.cabinTypeName ? isContainA = a.cabinTypeName.includes('经济') : isContainA=false
          b.cabinTypeName ? isContainB=b.cabinTypeName.includes('经济') : isContainB=false
          if(!isContainB && !isContainA){
            return 0;
          }
          // 对包含"经济"两个字的舱进行排序
          // 将包含的舱排在前面，不包含的舱或其他舱排在后面
          if (isContainA && !isContainB) {
            return -1;
          } else if (!isContainA && isContainB) {
            return 1;
          } else {
            return 0;
          }
        });
      }
      this.cabinTypeList = arr
    },
    changeTab(a, b) {
    },
    changeCollapse(a) {
      this.showMore(a)
    },
    //预订
    async book(price, cabin, priceId) {
      this.infoprice = price
      if (this.$store.state.tk.minFlightRemark != '') {
        this.bookseparate(price, cabin, priceId)
        return
      }
      let res = await this.$api['tkQuery/validateMinPrice']({
        cacheId: this.flights.cacheId,
        priceId: price.priceId,
        flightNo: this.flights.flightNo,
        cabin: price.cabin,
        checkType: "2",
      })
      let userInfo = JSON.parse(localStorage.getItem('userInfo'))
      if (res.errCode != 1 && userInfo.empInfo.isVip != 1) {
        this.showBottomfraud = true
      } else {
        this.$store.commit('tk/selectreason', '')
        this.bookseparate(price, cabin, priceId)
      }

    },
    //最终点击的确定
    selectook(price){
      if(this.selectreason==''){
        return this.$toast('请填写原因')
      }
      this.showBottomfraud=false //关弹窗
      this.nextstep=true //显示第一页
      this.bookseparate(price)
      //存选择这个话的原因
      this.$store.commit('tk/selectreason',this.selectreason)
    },
    //预计编辑分开
    bookseparate(price, cabin, priceId){
      sessionStorage.setItem('priceId', JSON.stringify(price.priceId))
      this.i = price.checkJs
      if (price.salePrice == 0) {
        this.$toast('请先获取价格')
        return
      }
      this.price = price
      this.cabin = {
        cabin: price.cabin,
        cabinName: price.cabinName,
        minPrice: price.minPrice,
      }
      if (this.tkSearchInfo.violateList) {
        this.wbxs = this.tkSearchInfo.violateList[price.priceId]
      }
      var str1 = '您当前预订的产品来自于外部电商网站，非服务商从中航信直采产品，服务商不能够保证及时出票以及价格是否会发生变动，最终结果以出票为准。',
        str2 = '您当前预订的产品来自于外部电商网站特惠产品，销售价格与行程单上的价格会不符，服务商不能够保证及时出票以及价格是否会发生变动，最终结果以出票为准。',
        str3 = '如遇任何问题，服务商会协助您进行处理，但最终解释权归第三方电商平台所有。',
        str4 = '我已知悉产品风险，如遇问题，愿意配合服务商进行处理',
        self = this
      if (this.price.productType == 2) {
        if (this.price.markList && this.price.markList.length > 0) {
          this.price.markList.forEach(function (item) {
            if (item.markCode == 'WNFX01' || item.markCode == 'WNFX02') {
              self.showModal = true
              self.prodectTips = {
                str1: str2,
                str2: str3,
                str3: str4,
              }
            } else if (item.markCode == 'WNFX03' || item.markCode == 'WNFX04' || item.markCode == 'WNFX05') {
              self.showModal = true
              self.prodectTips = {
                str1: str1,
                str2: str3,
                str3: str4,
              }
            }
          })
        }
      }
      if (this.showModal == false) {
        this.goEdit()
      }
      sessionStorage.setItem('flights', JSON.stringify(this.flights))
    },
    tobook: function (action, done) {
      if (action == 'cancel') {
        done()
      } else if (this.haveRead) {
        done()
        this.goEdit()
      } else {
        this.$toast('请勾选我已知悉产品风险')
        done(false)
        return 
      }
    },
    // back(){
    //   console.log(123456)
    //   this.$router.back()
    // },
    goEdit() {//去订单填写
      //舱位数量
      if (this.tkSearchInfo.travelerList) {
        let cxrlength = this.tkSearchInfo.travelerList.length
        if (this.price.seatCount < cxrlength) {
          this.$toast('您选择的舱位剩余不足，请重新选择舱位，或修改出行人数！')
          return false
        }
      }
      this.timeOut()
    },
    async timeOut() {//判断是否超时
      let out = await this.$api['tkQuery/validateTimeOut']({
        'cacheId': this.flights.cacheId,
        'cabinKey': this.flights.departDate + '_' + this.flights.flightNo + '_' + this.cabin.cabin
      })
      if (out.errCode == 1) {
        //获取违背信息
        if (this.tkSearchInfo.violateList && Object.keys(this.tkSearchInfo.violateList).length > 0) {
          this.tkSearchInfo.violate = this.tkSearchInfo.violateList[this.price.priceId]
          if(this.lvShow && this.tkSearchInfo.violateList[this.price.priceId] && this.tkSearchInfo.violateList[this.price.priceId]['violateItem']){
            let tempCode = this.tkSearchInfo.violate.violateCode.split(';')
            let tempText = this.tkSearchInfo.violate.violateItem.split(';')
            let tempList = tempText.map(item => {
              if (tempCode.includes('11102') && item.includes('折')) {
                return '折扣超标';
              } else if(tempCode.includes('11105') && (item.includes('航班最低价') && !item.includes('次低'))){
                return "价格超标";
              } else if((tempCode.includes('11113') && item.includes('日期范围')) || (tempCode.includes('11115') && item.includes('不大于'))){
                return "时间超标"
              } else {
                return item;
              }
            });
            tempList = [...new Set(tempList)];
            this.$set(this.tkSearchInfo.violate,'violateItem',tempList.join(";"))
          }
        }
        this.flights.price = this.price
        this.flights.cabin = this.cabin
        this.flights.cabinKey = this.flights.departDate + '_' + this.flights.flightNo + '_' + this.cabin.cabin
        this.tkSearchInfo.flights[this.tkSearchInfo.roundtrip] = this.flights
        // if (this.tkSearchInfo.queryStr.travelType == 2 && this.tkSearchInfo.roundtrip == 0) {
        //   this.tkSearchInfo.roundtrip += 1
        // }
        this.$store.commit('tk/tkSearchInfo', this.tkSearchInfo)
        this.noTimeOut()
      }
    },
    noTimeOut() {//未超时
      console.log('this.tkSearchInfo.violate', this.tkSearchInfo.violate)
      let violate = this.tkSearchInfo.violate
      if (violate && violate.canBook == 1) {
        if ((violate.violateItem || violate.violateCode) && !violate.reasonDesc) {
          // this.$refs.violateList.toggle({violate:violate,cplx:'10901'})//选择违背原因
          this.$refs.violateList.toggle({violate: violate, cplx: '11601035'}) // 机票超标原因
        } else {
          this.$router.push({path: this.path, query: {text: '我是阿格斯之盾', i: this.i, GoBack: true}})
        }
      } else if (violate && violate.canBook == 0) {
        this.$toast('当前舱位不可预订,因违背' + violate.violateItem)
      } else {
        this.$router.push({path: this.path, query: {text: '我是阿格斯之盾', i: this.i, GoBack: true}})
      }
    },
    //获取浮动价格erto
    getPriceForFloat(price, name, index1, index3) {
      this.$api['tkQuery/patForFlight']({
        'cabin': price.cabin,
        'cacheId': this.flights.cacheId,
        'flightNo': this.flights.flightNo,
        'priceId': price.priceId,
        'tripType': this.tripType
      }).then(res => {
        let cache = res.data || {}
        if (cache.salePrice) {
          this.cabinTypeList[index1][name][index3].salePrice = cache.salePrice
          this.cabinTypeList[index1][name][index3].discount = cache.saleDiscount
          if (this.tkSearchInfo.matchClbz) {
            this.matchClbz()
          }
        }
      })
    },
    // 获取是否违背
    matchClbz() {
      let routeId
      if (this.$route.query.routeId) { //如果有值
        routeId = this.$route.query.routeId
      } else if (this.tkSearchInfo.queryStr.tripType == 1 && this.vipCorp.bookStyle == 2 && this.tkSearchInfo.voyage) { //因公模式并且是出差申请单模试
        routeId = this.tkSearchInfo.voyage.routeId
      }else{
        routeId = this.tkSearchInfo.voyage.routeId
      }
      this.$api['tkQuery/matchClbz']({
        'cacheId': this.flights.cacheId,
        'minZj': this.tkSearchInfo.queryStr.empRank,
        'routeId': routeId,
        'ccsqdId': this.tkSearchInfo.ccsqd.ccsqdId,
        'auditType': this.tkSearchInfo.ccsqd.auditType,
      }).then(res => {
        let cache = res.data || {}
        this.tkSearchInfo.violateList = cache
      })
    },
    // 展示更多舱位
    showMore(index) {
      let list = this.cabinTypeList[index]
      let limit = list.limit
      if (limit == 1) {
        list.limit = 20
      } else {
        list.limit = 1
      }
      this.$set(this.cabinTypeList, index, list)
      this.$forceUpdate()
    },
    //显示退改规则
    showRule(cabin, priceId) {
      this.changeRule = {
        'cacheId': this.flights.cacheId,
        'flightNo': this.flights.flightNo,
        'cabin': cabin,
        'priceId': priceId,
        'isWn': true
      }
      this.$refs.rule.toggle(this.flights)
    },
    // 显示产品标签及颜色
    showProduct(index) {
      // 仅展示最低价
      if (this.showFirstProductTypeTips) {
        return 0 == index ? true : false
      } else {
        //正常展示标签
        return this.showProductTypeTips
      }
    },
    //对龙旅特殊处理
    isLvShow() {
      let temp = window.location.href;
      if (temp.includes("localhost") ||temp.includes("app.longlv.tmc.tianxiafen.com") || temp.includes("app.xinglu.com")) {
        this.lvShow = true;
      } else {
        this.lvShow = false;
      }
    },
  },
  filters: {
    cabinType(type) {
      var obj = {'F': '头等舱', 'B': '公务舱', 'E': '经济舱', 'ES': '高端经济舱/明珠舱', 'T': '特价舱'}
      return obj[type] || ''
    },
    seatCount(seat) {//座位
      if (seat == 'A') {
        return '充足'
      } else if (typeof (parseInt(seat)) === 'number') {
        return '余' + seat + '张'
      } else {
        return seat
      }
    },
    discount(val) {//计算折扣
      if (!val) return
      if (val < 10) {
        return val.toFixed(1) + '折'
      } else if (val == 10) {
        return '全价'
      } else if (val > 10) {
        val = Math.floor(val) / 10
        return val + '倍'
      } else {
        return 0
      }
    }
  },
}


function cabinPriceSort(cabinMap) { //舱位内价格排序
  cabinMap.forEach(function (item) {
    if (item.priceList && item.priceList.length > 0) {
      item.priceList.sort(function (a, b) {
        return a.salePrice - b.salePrice
      })
      var cache = item.priceList
      var arr = []
      for (var i = cache.length - 1; i >= 0; i--) {
        if (!cache[i].salePrice || cache[i].salePrice <= 0) {
          arr.push(cache.pop())
        }
      }
      item.priceList = cache.concat(arr)
      item.minPrice = item.priceList[0].salePrice
    }
  })

  cabinMap.sort(function (a, b) {
    return a.minPrice - b.minPrice
  })

  var arr = []
  for (var i = cabinMap.length - 1; i >= 0; i--) {
    if (cabinMap[i].priceList && cabinMap[i].priceList.length == 1 && cabinMap[i].priceList[0].salePrice == 0) {
      arr.push(cabinMap.splice(i, 1)[0])
    }
  }
  cabinMap = cabinMap.concat(arr)

  return cabinMap
}

function limitCabin(cabinTypeList, limit) {//筛选舱位 只保留最低价几个舱位
  cabinTypeList.filter(function (item) {
    item.cabinMap = objToArr(item.cabinMap)
    item.cabinMap = cabinPriceSort(item.cabinMap)
    if (limit > 0) {
      item.cabinMap = item.cabinMap.splice(0, limit)
    }
  })
  return cabinTypeList
}

function closeFB(list) {
  return list.filter(function (item) {
    return (item.cabinType != 'F' && item.cabinType != 'B')
  })
}

</script>
<style lang="less" scoped>
@import '~Assets/styles/business';

.tkCabin {
  .cabinTitle {
    margin-bottom: 5px;
    border-radius: 4px;
  }

  .cabinListBox {
    margin-bottom: 5px;

    .cabinListContent {
      background-color: @color-background-white;
      position: relative;

      .cabinList {
        padding: 14px;
      }
    }
  }

  .pad-10 {
    padding: 10px;
  }

  .pad-tb-6 {
    padding-top: 6px;
    padding-bottom: 6px;
  }

  .pad-tb-4 {
    padding-top: 4px;
    padding-bottom: 4px;
  }

  .pad-tb-10 {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .indent {
    text-indent: 20px;
  }

  .dropdown {
    height: 40px;
    padding: 10px 15px;
    background-color: @color-background-white;
    box-shadow: 0px 8px 35px 0px rgba(0, 0, 0, 0.05);

    span {
      vertical-align: text-bottom;
    }
  }

  .gw {
    display: inline-block;
    width: 30px;
    height: 20px;
    background-image: linear-gradient(-90deg,
    #caa466 0%,
    #e1c48a 100%);
    font-size: @font-size-10;
    text-align: center;
    color: @color-text-white;
    border: 1px solid #e1c48a;
    border-radius: 4px;
  }

  .box {
    padding: 0 8px;
  }

  .tkCabinwrapper {
    height: calc(100vh - 180px);
    //height: calc(100vh - 395px);
    overflow: hidden;
    border-radius: 4px
  }
}

.borderRadius {
  border-radius: 4px;
}

.borderBotRadius {
  border-radius: 0px 0px 4px 4px;
}

/deep/ .van-tabs__nav {
  position: relative;
  display: flex;
  background-color: #fff;
  user-select: none;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
}

.YoungAndOld {
  border-width: 0px;
  background: inherit;
  background-color: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(208, 164, 100, 1);
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-size: 10px;
  color: #D9692A;
  margin: 0px 10px 0 0;
  padding: 0px 5px 0 5px;
}

.ert {
  font-size: 12px;
  color: #7b7b7b;
}

.ert1 {
  font-size: 12px;
  color: #7b7b7b;
  margin: 5px 0px 5px 0;
}
.fraudl{
   width: 100%;
   height: 100%;
   flex-direction: column;
   display: flex;
   /* justify-content: center; */
   align-items: center;
   justify-content: center;
   /* justify-content: space-between; */
  //  justify-content: space-evenly;

}
.select{
  width: 60%;
    display: flex;
    justify-content: space-evenly;
    margin-top: 14px;
}
.reason{
   padding: 16px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    // align-items: flex-end;

}
.fieldcas{
    height: 15vh;
    width: 52vw;
}
.selectokd{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.newharignl {
  border: 1px solid #ccc;
  // box-shadow: 0 4px 4px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.1),
  //   0 8px 16px rgba(0, 0, 0, 0.1);
  // margin-bottom: 10px;
  /* margin-bottom: 10px; */
  margin-bottom: 2px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.1);
  // margin-bottom: 6px;
}
.newharignltow{
  margin-bottom: 2px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.1)
}
.harignl {
  padding-top:0;
  padding-bottom: 4px;
}
.harignnew {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.markListbox{
  background-color: #fff;
    color: #d9692a;
    font-size: 13px;
    // font-weight: 600;
}
.maskclice{
  background-color: #fdf3e6;
  // background-color: #fffcf5;
    /* width: 18%; */
    height: 28px;
    /* display: flex; */
    /* justify-content: center; */
    /* align-items: center; */
    padding: 5px 10px;
    display: inline-block;
    text-align: center;
}
.back_padd{
  background-color: #fffcf5;
  padding: 10px 16px;
  font-size: 12px;
}
.dis_juc_wra{
    display: flex;
    justify-content: space-between;

    flex-wrap: wrap;
}
.width50{
  width:50%;
  margin-bottom: 5px;
}
.iconfontcolr{
  font-size: 16px;
    color: #d9692a;
    margin-right: 4px;

}
.dis_juc_vut{
  display: flex;
  align-items: center;
}
/deep/ .van-collapse-item__content{
  padding: 0px !important;
}
.newhairline{
  padding: 12px 16px;
}
.back_padd:empty{
  display:none
}
/deep/ .van-cell__right-icon {
  display: none;
}

</style>
